<template>
  <div id="phone-number-component">
    <div class="form-group">
      <label v-if="label !== ''" :for="name"> {{ label }} </label>
      <div class="input-group">
        <input
          v-model="localValue"
          :id="`${name}-${index || ''}`"
          type="text"
          class="form-control form-control-sm"
          v-maska
          data-maska="+##-############'"
          :placeholder="placeholder"
          :name="name"
          autocomplete="off"
          :readonly="isDisable"
          @blur="$emit('blurEvent', name, index)"
          @input="e => $emit('inputEvent', e)"
        />
        <small class="text-muted"> {{ additionalMessage }} </small>
        <error-message-new
          v-if="!fieldState"
          :index="index"
          :errors="errors"
          :fieldName="name"
          :parent="parent"
          :ui-error-message="uiErrorMessage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { vMaska } from "maska";

import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  name: "PhoneNumberInput",
  directives: { maska: vMaska },
  props: {
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: null,
    },
    size: {
      type: String,
      default: "sm",
    },
    isDisable: {
      type: Boolean,
      default: null,
    },
    parent: {
      type: String,
      default: null,
    },
    additionalMessage: {
      type: String,
      default: "",
    },
    showError: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: [Array],
      default: () => [],
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
    uiErrorMessage: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    localValue: null,
  }),
  computed: {
    fieldState() {
      return (
        this.$hasField({
          name: this.name,
          errors: this.errors,
          index: this.index,
          parent: this.parent,
        }) && this.showError
      );
    },
  },
  methods: { $hasField, handleFieldState },
};
</script>
